import BasePage from  './basePage';

export default class Benefits1 extends BasePage{
  constructor(info){
    super(info);
    this.showMotion;
    this._motionSet();
    this.isMouseMove = false;
    this.mousePosition = '';
    this.center = 960;
    this.cardLeftMotion;
    this.cardRightMotion;

  }
  _motionSet(){
    this.showMotion = new TimelineMax({paused: true});
    this.showMotion
      .fromTo(this.ele.querySelector('.chr-1'), 3, {autoAlpha:0, x:400}, {autoAlpha:1, x:0, ease: 'chr'}, '+=0.5')
      .fromTo(this.ele.querySelector('.chr-1>span'), 1, {autoAlpha:0.8}, {autoAlpha:0, ease: Quart.easeInOut}, '-=2')

      .addLabel('obj', '-=2.5')
      .fromTo(this.ele.querySelector('.txt-1'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj')
      .fromTo(this.ele.querySelector('.txt-2'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj+=0.3')
      .fromTo(this.ele.querySelector('.txt-1>span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Quart.easeOut}, 'obj+=0.6')
      .fromTo(this.ele.querySelector('.card-left'), 1, {autoAlpha:0, x:0}, {autoAlpha:1, x:0, ease: Quart.easeOut}, 'obj+=0.8')
      .fromTo(this.ele.querySelector('.card-right'), 1, {autoAlpha:0, x:0}, {autoAlpha:1, x:0, ease: Quart.easeOut, onComplete: this._showCompleteContent, onCompleteParams: [this]}, 'obj+=0.8')
      .fromTo(this.ele.querySelector('.icon-scroll'), 0.5, {autoAlpha:0, y:50}, {autoAlpha:0.8, y:0, ease: Quart.easeOut}, 'obj+=1.1')

    this.cardLeftMotion = new TimelineMax({paused:true});
    this.cardRightMotion = new TimelineMax({paused:true});
    this.cardLeftMotion
      .to(this.ele.querySelector('.card-left'), 0.75, {
          bezier:{
            type:"soft",
            values:[{x:-75, y:0, scale:0.8675}, {x:0, y:0, scale:1}]
          },
          ease:Power1.easeInOut}
        )
      .to(this.ele.querySelector('.card-left dd'), 0.75, {x:0, autoAlpha:1, ease:Power2.easeInOut}, '0')
      .to(this.ele.querySelector('.card-left .over-bg'), 0.75, {autoAlpha:0, ease:Power2.easeOut}, '0')
      .to(this.ele.querySelector('.card-left .over-line'), 0.75, {autoAlpha:1, ease:Power2.easeOut}, '0')
    this.cardRightMotion
      .to(this.ele.querySelector('.card-right'), 0.75, {
        bezier:{
          type:"soft",
          values:[{x:75, y:0, scale:0.8675}, {x:0, y:0, scale:1}]
        },
        ease:Power1.easeInOut}
      )
      .to(this.ele.querySelector('.card-right dd.chr1'), 0.75, {x:0, autoAlpha:1, ease:Power2.easeInOut}, '0')
      .to(this.ele.querySelector('.card-right dd.chr2'), 0.75, {x:0, autoAlpha:1, ease:Power2.easeInOut}, '0')
      .to(this.ele.querySelector('.card-right .over-bg'), 0.75, {autoAlpha:0, ease:Power2.easeOut}, '0')
      .to(this.ele.querySelector('.card-right .over-line'), 0.75, {autoAlpha:1, ease:Power2.easeOut}, '0')


  };
  show(size, dx){
    super.show(size, dx)
    window.addEventListener("mousemove", this._mouseMove.bind(this))
    window.addEventListener('resize', this._resize.bind(this));
    this._resize();
    this.cardLeftMotion.seek(0)
    this.cardRightMotion.seek(0)
    this.showMotion.seek(0)
    this.showMotion.play();
   // window.mouseMove();
  }
  hide(size, dx, moveSec){
    super.hide(size, dx, moveSec)

    this.showMotion.pause();
    this.isMouseMove = false;
    this.mousePosition = '';
    window.removeEventListener('resize', this._resize.bind(this));
    window.removeEventListener("mousemove", this._mouseMove.bind(this));
    this.cardLeftMotion.pause();
    this.cardRightMotion.pause();
  }
  _mouseMove(e){
    if(!this.isMouseMove)return;
    let mPos = '';
    if(this.center <= e.clientX) mPos = 'right';
    if(this.center > e.clientX) mPos ='left' ;
    if(mPos == this.mousePosition)return;
    this.mousePosition = mPos;
    if(this.mousePosition == 'left'){
      this.cardLeftMotion.play();
      this.cardRightMotion.reverse();
    }else{
      this.cardLeftMotion.reverse();
      this.cardRightMotion.play();
    }
  }
  _resize(){
    this.center =  document.querySelector('.container').clientWidth / 2;
  }
  _showCompleteContent(thisv){
    thisv.isMouseMove = true;
    let events = new MouseEvent('mousemove',{
      clientX:Math.random()*thisv.center*2
    });
    window.dispatchEvent(events);
  }
}



// WEBPACK FOOTER //
// ./src/js/page/benefits1.js